(function(){
"use strict";

var stateData = {
  "Andhra Pradesh":{tds:"800\u20132000",hard:"Very Hard",lvl:5},
  "Arunachal Pradesh":{tds:"50\u2013150",hard:"Soft",lvl:1},
  "Assam":{tds:"50\u2013180",hard:"Soft",lvl:1},
  "Bihar":{tds:"200\u2013600",hard:"Moderate",lvl:3},
  "Chandigarh":{tds:"200\u2013450",hard:"Moderate",lvl:3},
  "Chhattisgarh":{tds:"546\u2013984",hard:"Hard",lvl:4},
  "Delhi":{tds:"100\u20131400",hard:"Very Hard",lvl:5},
  "Goa":{tds:"80\u2013200",hard:"Soft",lvl:1},
  "Gujarat":{tds:"300\u20131200",hard:"Very Hard",lvl:5},
  "Haryana":{tds:"200\u20132172",hard:"Extremely Hard",lvl:5},
  "Himachal Pradesh":{tds:"100\u2013300",hard:"Moderate",lvl:2},
  "Jammu and Kashmir":{tds:"120\u2013350",hard:"Moderate",lvl:2},
  "Jharkhand":{tds:"300\u2013800",hard:"Hard",lvl:4},
  "Karnataka":{tds:"120\u20131830",hard:"Very Hard",lvl:5},
  "Kerala":{tds:"50\u2013200",hard:"Soft\u2013Moderate",lvl:2},
  "Ladakh":{tds:"100\u2013250",hard:"Moderate",lvl:2},
  "Madhya Pradesh":{tds:"300\u2013500",hard:"Hard",lvl:4},
  "Maharashtra":{tds:"300\u20131500",hard:"Very Hard",lvl:5},
  "Manipur":{tds:"40\u2013120",hard:"Soft",lvl:1},
  "Meghalaya":{tds:"40\u2013100",hard:"Soft",lvl:1},
  "Mizoram":{tds:"40\u2013100",hard:"Soft",lvl:1},
  "Nagaland":{tds:"40\u2013120",hard:"Soft",lvl:1},
  "Odisha":{tds:"150\u2013400",hard:"Moderate",lvl:2},
  "Puducherry":{tds:"300\u2013800",hard:"Hard",lvl:4},
  "Punjab":{tds:"330\u2013940",hard:"Hard",lvl:4},
  "Rajasthan":{tds:"440\u20134125",hard:"Extremely Hard",lvl:5},
  "Sikkim":{tds:"30\u2013100",hard:"Soft",lvl:1},
  "Tamil Nadu":{tds:"500\u20131800",hard:"Very Hard",lvl:5},
  "Telangana":{tds:"226\u2013870",hard:"Very Hard",lvl:5},
  "Tripura":{tds:"50\u2013150",hard:"Soft",lvl:1},
  "Uttar Pradesh":{tds:"86\u2013900",hard:"Hard",lvl:4},
  "Uttarakhand":{tds:"100\u2013400",hard:"Moderate",lvl:3},
  "West Bengal":{tds:"100\u2013350",hard:"Moderate",lvl:2},
  "Andaman and Nicobar Islands":{tds:"150\u2013300",hard:"Moderate",lvl:2},
  "Dadra and Nagar Haveli and Daman and Diu":{tds:"200\u2013500",hard:"Moderate",lvl:3},
  "Lakshadweep":{tds:"100\u2013250",hard:"Moderate",lvl:2}
};

var colors = ["#FAFAF7","#FFF3C4","#FFD97D","#FF9F43","#E64A19","#B71C1C"];
var labels = ["","Soft (<200 ppm)","Moderate (200\u2013400 ppm)","Hard (400\u2013600 ppm)","Very Hard (600\u20131000 ppm)","Extremely Hard (>1000 ppm)"];

var hairByHard = {
  "soft":{
    short:"Hair feels smoother; shampoo lathers well",
    long:"Minimal mineral buildup on hair"
  },
  "moderate":{
    short:"Slight dryness or rough texture in some people",
    long:"Shine can fade slowly, especially with frequent washing"
  },
  "hard":{
    short:"Frizz, dryness, tangling & dullness",
    long:"More breakage, scalp irritation & color fading"
  },
  "very hard":{
    short:"Hair feels waxy or stiff; harder to rinse clean",
    long:"Brittle strands, thinning look & more breakage"
  },
  "extremely hard":{
    short:"Persistent dryness, itchiness & rough texture",
    long:"Heavy buildup, chronic brittleness & severe frizz"
  }
};

function hairEffects(sd){
  if(!sd) return null;
  var h = (sd.hard||"").toLowerCase().replace(/\u2013/g,"-");
  if(h.indexOf("extremely")>=0) return hairByHard["extremely hard"];
  if(h.indexOf("very")>=0) return hairByHard["very hard"];
  if(h.indexOf("moderate")>=0) return hairByHard["moderate"];
  if(h.indexOf("soft")>=0) return hairByHard["soft"];
  if(h.indexOf("hard")>=0) return hairByHard["hard"];
  var lvl = sd.lvl||3;
  if(lvl<=1) return hairByHard["soft"];
  if(lvl===2) return hairByHard["moderate"];
  if(lvl===3) return hairByHard["hard"];
  if(lvl===4) return hairByHard["very hard"];
  return hairByHard["extremely hard"];
}

function updateStateDetail(name){
  var empty = document.getElementById("ihm-detail-empty");
  var panels = document.getElementById("ihm-detail-panels");
  if(!empty||!panels) return;
  var sd = find(name);
  if(!sd){
    empty.style.display = "flex";
    panels.style.display = "none";
    return;
  }
  var fx = hairEffects(sd);
  empty.style.display = "none";
  panels.style.display = "flex";
  document.getElementById("ihm-detail-state").textContent = name;
  document.getElementById("ihm-detail-ppm").textContent = sd.tds;
  document.getElementById("ihm-detail-hard").textContent = sd.hard;
  document.getElementById("ihm-detail-short").textContent = fx.short;
  document.getElementById("ihm-detail-long").textContent = fx.long;
}

function clearStateDetail(){
  var empty = document.getElementById("ihm-detail-empty");
  var panels = document.getElementById("ihm-detail-panels");
  if(!empty||!panels) return;
  empty.style.display = "flex";
  panels.style.display = "none";
}

function find(name){
  if(stateData[name]) return stateData[name];
  for(var k in stateData){ if(name.indexOf(k)>-1||k.indexOf(name)>-1) return stateData[k]; }
  return null;
}

function init(){
  var el = document.getElementById("india-hardwater-map");
  if(!el) return;

  el.innerHTML =
    '<div class="ihm-wrap">'+
      '<div class="ihm-map-panel">'+
        '<div class="ihm-controls">'+
          '<button class="ihm-btn" id="ihm-back" title="Back to full map" style="display:none">&#8592; Back</button>'+
        '</div>'+
        '<div class="ihm-state-label" id="ihm-state-label" style="display:none"></div>'+
        '<div class="ihm-svg-box" id="ihm-box"><div style="text-align:center;padding:4rem 1rem;color:#999">Loading map&hellip;</div></div>'+
        '<div class="ihm-tooltip" id="ihm-tip"></div>'+
      '</div>'+
      '<aside class="ihm-sidebar">'+
        '<div class="ihm-legend" id="ihm-leg"></div>'+
        '<div class="ihm-sidebar-main">'+
          '<div class="ihm-stat ihm-stat--lead">'+
            '<span class="ihm-num">85%</span>'+
            '<span class="ihm-lbl">of homes face hard water</span>'+
          '</div>'+
          '<div class="ihm-stat">'+
            '<span class="ihm-num">600+</span>'+
            '<span class="ihm-lbl">ppm where brittle hair &amp; breakage start</span>'+
          '</div>'+
          '<div class="ihm-stat">'+
            '<span class="ihm-num">4125</span>'+
            '<span class="ihm-lbl">peak TDS recorded &mdash; Rajasthan</span>'+
          '</div>'+
          '<div class="ihm-state-detail" id="ihm-detail">'+
            '<div class="ihm-detail-empty" id="ihm-detail-empty">'+
              '<span class="ihm-detail-hint">Select a state on the map</span>'+
            '</div>'+
            '<div class="ihm-detail-panels" id="ihm-detail-panels" style="display:none">'+
              '<div class="ihm-detail-card">'+
                '<span class="ihm-detail-state" id="ihm-detail-state"></span>'+
                '<span class="ihm-detail-ppm" id="ihm-detail-ppm"></span>'+
                '<span class="ihm-detail-unit">ppm TDS</span>'+
                '<span class="ihm-detail-hard" id="ihm-detail-hard"></span>'+
                '<span class="ihm-detail-lbl">Short-term effects on hair</span>'+
                '<p class="ihm-detail-text" id="ihm-detail-short"></p>'+
                '<span class="ihm-detail-lbl">Long-term effects on hair</span>'+
                '<p class="ihm-detail-text" id="ihm-detail-long"></p>'+
              '</div>'+
            '</div>'+
          '</div>'+
        '</div>'+
      '</aside>'+
    '</div>';

  var leg = document.getElementById("ihm-leg");
  for(var i=1;i<=5;i++){
    leg.innerHTML += '<div class="ihm-leg-item"><span class="ihm-leg-c" style="background:'+colors[i]+'"></span><span>'+labels[i]+'</span></div>';
  }

  var dataUrl = el.getAttribute("data-map-url");
  if(!dataUrl){
    var scripts = document.querySelectorAll('script[src*="india-hardwater-map"]');
    if(scripts.length){
      dataUrl = scripts[0].src.replace("india-hardwater-map.js","india-map-data.json");
    }
  }
  if(!dataUrl) dataUrl = "/assets/india-map-data.json";

  fetch(dataUrl)
    .then(function(r){ if(!r.ok) throw new Error(r.status); return r.json(); })
    .then(function(paths){ render(paths); })
    .catch(function(){
      document.getElementById("ihm-box").innerHTML =
        '<div style="text-align:center;padding:3rem 1rem;color:#999">'+
        '<p>Map could not load.</p>'+
        '<button onclick="location.reload()" style="margin-top:0.5rem;padding:0.5rem 1.5rem;border:1px solid #ccc;background:#fff;border-radius:6px;cursor:pointer">Retry</button>'+
        '</div>';
    });
}

function render(paths){
  var box = document.getElementById("ihm-box");
  var tip = document.getElementById("ihm-tip");
  var backBtn = document.getElementById("ihm-back");
  var stateLabel = document.getElementById("ihm-state-label");
  var W = 600, H = 690;
  var zoomed = false;
  var fullView = {x:0, y:0, w:W, h:H};
  var currentView = {x:0, y:0, w:W, h:H};
  var zoomAnimId = null;
  var ZOOM_MS = 600;

  function isMobileMap(){
    return window.matchMedia("(max-width: 749px)").matches;
  }

  function setMobileBoxAspect(){
    if(!isMobileMap()) return;
    box.classList.add("ihm-zoomed");
  }

  function resetMobileBoxAspect(){
    if(!isMobileMap()) return;
    box.classList.remove("ihm-zoomed");
    box.style.aspectRatio = "";
    box.style.maxHeight = "";
  }

  function hideMapOverlays(){
    tip.style.display = "none";
    tip.style.transform = "";
    tip.style.left = "";
    tip.style.top = "";
    stateLabel.style.display = "none";
  }

  function viewBoxTarget(path){
    var bbox = path.getBBox();
    var pad = 30;
    var vx = bbox.x - pad;
    var vy = bbox.y - pad;
    var vw = bbox.width + pad * 2;
    var vh = bbox.height + pad * 2;
    var mapAspect = W / H;
    var stateAspect = vw / vh;
    if(stateAspect > mapAspect){
      var extra = vw / mapAspect - vh;
      vy -= extra / 2;
      vh += extra;
    } else {
      var extra2 = vh * mapAspect - vw;
      vx -= extra2 / 2;
      vw += extra2;
    }
    return {x:vx, y:vy, w:vw, h:vh};
  }

  function applyViewBox(v){
    currentView = {x:v.x, y:v.y, w:v.w, h:v.h};
    svgEl.setAttribute("viewBox", v.x+" "+v.y+" "+v.w+" "+v.h);
  }

  function animateViewBox(target, onDone){
    if(zoomAnimId) cancelAnimationFrame(zoomAnimId);
    var start = {x:currentView.x, y:currentView.y, w:currentView.w, h:currentView.h};
    var t0 = null;
    function ease(p){ return 1 - Math.pow(1 - p, 3); }
    function step(ts){
      if(!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / ZOOM_MS);
      var e = ease(p);
      applyViewBox({
        x: start.x + (target.x - start.x) * e,
        y: start.y + (target.y - start.y) * e,
        w: start.w + (target.w - start.w) * e,
        h: start.h + (target.h - start.h) * e
      });
      if(p < 1){
        zoomAnimId = requestAnimationFrame(step);
      } else {
        zoomAnimId = null;
        applyViewBox(target);
        if(onDone) onDone();
      }
    }
    zoomAnimId = requestAnimationFrame(step);
  }

  function afterViewChange(){}

  var svg = '<svg viewBox="0 0 '+W+' '+H+'" preserveAspectRatio="xMidYMid meet" style="display:block;width:100%;height:100%" xmlns="http://www.w3.org/2000/svg"><g id="ihm-g">';

  paths.forEach(function(p,i){
    var sd = find(p.n);
    var fill = sd ? colors[sd.lvl] : "#E5E5E5";
    svg += '<path d="'+p.d+'" fill="'+fill+'" stroke="#fff" stroke-width="1.2" data-i="'+i+'" data-name="'+p.n.replace(/"/g,"&quot;")+'" class="ihm-state" />';
  });

  svg += '</g></svg>';
  box.innerHTML = svg;

  var svgEl = box.querySelector("svg");

  var gEl = document.getElementById("ihm-g");

  svgEl.addEventListener("mouseover",function(e){
    if(isMobileMap()) return;
    var t = e.target.closest("path[data-name]");
    if(!t) return;
    t.style.opacity = "0.75";
    t.setAttribute("stroke","#1A2E30");
    t.setAttribute("stroke-width","1.5");
    var name = t.getAttribute("data-name");
    var sd = find(name);
    tip.innerHTML = sd
      ? '<strong>'+name+'</strong><br>TDS: '+sd.tds+' ppm<br>'+sd.hard
      : '<strong>'+name+'</strong>';
    tip.style.display = "block";
  });

  svgEl.addEventListener("mousemove",function(e){
    if(isMobileMap()) return;
    var rect = box.getBoundingClientRect();
    var x = e.clientX - rect.left + 14;
    var y = e.clientY - rect.top - 10;
    if(x + 180 > rect.width) x = e.clientX - rect.left - 190;
    if(y < 0) y = 10;
    tip.style.left = x+"px";
    tip.style.top = y+"px";
  });

  svgEl.addEventListener("mouseout",function(e){
    if(isMobileMap()) return;
    var t = e.target.closest("path[data-name]");
    if(!t) return;
    t.style.opacity = "1";
    t.setAttribute("stroke","#fff");
    t.setAttribute("stroke-width","0.6");
    tip.style.display = "none";
  });

  function zoomToState(path){
    if(zoomed) return;
    var name = path.getAttribute("data-name");
    var sd = find(name);
    var target = viewBoxTarget(path);
    stateLabel.innerHTML = '<strong>'+name+'</strong>' + (sd ? ' &mdash; TDS: '+sd.tds+' ppm ('+sd.hard+')' : '');
    stateLabel.style.display = "block";
    backBtn.style.display = "flex";
    zoomed = true;
    setMobileBoxAspect();
    animateViewBox(target, function(){
      updateStateDetail(name);
      afterViewChange();
    });
  }

  function resetZoom(){
    if(!zoomed) return;
    zoomed = false;
    hideMapOverlays();
    backBtn.style.display = "none";
    clearStateDetail();
    animateViewBox(fullView, function(){
      resetMobileBoxAspect();
      afterViewChange();
    });
  }

  svgEl.addEventListener("click",function(e){
    var t = e.target.closest("path[data-name]");
    if(!t){ if(zoomed) resetZoom(); return; }
    if(zoomed){ resetZoom(); return; }
    zoomToState(t);
  });

  backBtn.addEventListener("click",function(e){
    e.stopPropagation();
    resetZoom();
  });

  svgEl.addEventListener("touchstart",function(e){
    if(e.touches.length===1){
      var t = e.target.closest("path[data-name]");
      if(t && !zoomed){
        e.preventDefault();
        hideMapOverlays();
        zoomToState(t);
      } else if(zoomed){
        e.preventDefault();
        resetZoom();
      }
    }
  });

}

if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",init); else init();
})();
